import { render, staticRenderFns } from "./AssetTreeMenu.vue?vue&type=template&id=a268980a&scoped=true"
import script from "./AssetTreeMenu.vue?vue&type=script&lang=js"
export * from "./AssetTreeMenu.vue?vue&type=script&lang=js"
import style0 from "./AssetTreeMenu.vue?vue&type=style&index=0&id=a268980a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a268980a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a268980a')) {
      api.createRecord('a268980a', component.options)
    } else {
      api.reload('a268980a', component.options)
    }
    module.hot.accept("./AssetTreeMenu.vue?vue&type=template&id=a268980a&scoped=true", function () {
      api.rerender('a268980a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Handover/AssetTreeMenu.vue"
export default component.exports